import React, { forwardRef } from "react";

import { Switch } from "antd";

export default forwardRef((props, ref) => (
  <Switch ref={ref} onChange={props.onChange} checked={props.value} />
));
